import { JSONValue } from '@lucidtech/las-sdk-browser';

import { AnthropicIcon, ChatGPTIcon, GoogleGeminiIcon } from '@/components/icons';
import { ModelMetadata } from '@/store';

export type UserSettings = {
  temperature?: number;
  similarity_threshold?: number;
  cross_validation_limit?: number;
  hallucination_tolerance?: number;
  use_few_shot_learning?: boolean;
  base_model?: string;
};

export const USER_SETTINGS_DEFAULT: UserSettings = {
  temperature: 0.5,
  similarity_threshold: 0.6,
  cross_validation_limit: 0.1,
  hallucination_tolerance: 0.7,
  use_few_shot_learning: true,
  base_model: 'sonnet40',
};

export const toNumber = (value: number | number[], defaultValue?: number) => {
  if (typeof value === 'number') {
    return value;
  } else {
    return defaultValue ?? 0;
  }
};

export const LLM_MODELS = [
  {
    id: 'sonnet40',
    name: 'Claude Sonnet 4.0',
    value: 'sonnet40',
    icon: <AnthropicIcon className="opacity-50" />,
    isDefault: false,
    isDisabled: true,
  },
  {
    id: 'sonnet37',
    name: 'Claude Sonnet 3.7',
    value: 'sonnet37',
    icon: <AnthropicIcon />,
    isDefault: true,
  },
  {
    id: 'gpt5-o',
    name: 'GPT-5o',
    value: 'gpt5-o',
    icon: <ChatGPTIcon className="opacity-50" />,
    isDisabled: true,
  },
  {
    id: 'gemini-25-pro',
    name: 'Gemini 2.5 Pro',
    value: 'gemini-25-pro',
    icon: <GoogleGeminiIcon className="opacity-50" />,
    isDisabled: true,
  },
];

export const LOW_HIGH = [
  { id: 'low', name: 'Low', value: 'low' },
  { id: 'medium', name: 'Medium', value: 'medium ' },
  { id: 'high', name: 'High', value: 'high' },
];

export const stripReservedKeys = (config: ModelMetadata | JSONValue): ModelMetadata | JSONValue => {
  if (typeof config !== 'object' || Array.isArray(config)) {
    return config;
  }

  const result: ModelMetadata = {};
  for (const key of Object.keys(config || {})) {
    if (key.includes('cradl:') || key.includes('las:')) {
      continue;
    }

    if (config?.[key] != null) {
      result[key] = stripReservedKeys(config[key]);
    }
  }

  return result;
};
